import { j as n } from "../jsx-runtime-ClSzPYp4.js";
import { createPortal as i } from "react-dom";
import d from "./LoadingSpinner.mjs";
const s = ({ LoadingSpinner: o = d, domElementId: t, ...r }) => {
  let e = document.getElementById(t);
  return e || (e = document.createElement("div"), e.setAttribute("id", t), document.body.prepend(e)), /* @__PURE__ */ i(/* @__PURE__ */ n.jsx(o, {
    position: "fixed",
    ...r
  }), e);
};
export {
  s as default
};
